import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../../endpoint";
import type { PricingSection, PricingFeature, PricingTier } from "../types";

export const getPricing = async (): Promise<PricingSection> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.CMS.PRICING.GET);
  return data.section;
};

export const updatePricingSection = async (
  payload: Pick<PricingSection, "cardTitle" | "perStudentCost" | "costLabel" | "renewalHeading" | "gstPercentage" | "offer">
): Promise<PricingSection> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.PRICING.UPDATE, payload);
  return data.section ?? data;
};

export const addFeature = async (payload: Omit<PricingFeature, "id">): Promise<PricingFeature> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.CMS.PRICING.ADD_FEATURE, payload);
  return data.feature ?? data;
};

export const removeFeature = async (featureId: number): Promise<number> => {
  await privateClient.delete(SUPER_ADMIN_ENDPOINTS.CMS.PRICING.REMOVE_FEATURE(featureId));
  return featureId;
};

export const addTier = async (payload: Omit<PricingTier, "id" | "totalAnnualCost">): Promise<PricingTier> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.CMS.PRICING.ADD_TIER, payload);
  return data.tier ?? data;
};

export const updateTier = async (tierId: number, payload: Omit<PricingTier, "id" | "totalAnnualCost">): Promise<PricingTier> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.PRICING.UPDATE_TIER(tierId), payload);
  return data.tier ?? data;
};

export const removeTier = async (tierId: number): Promise<number> => {
  await privateClient.delete(SUPER_ADMIN_ENDPOINTS.CMS.PRICING.REMOVE_TIER(tierId));
  return tierId;
};